import { Box, Grid, Typography } from "@mui/material";
// import backgroundImage from "../../../assets/img/Rectangle.png";
import backgroundImage from "../../../assets/img/login-background-image.jpg";

interface HomePageWrapperProps {
  children?: React.ReactNode;
}

const HomePageWrapper: React.FC<HomePageWrapperProps> = ({ children }) => {
  return (
    <Box sx={{ height: "100vh", width: "100vw" }}>
      <Grid container sx={{ height: "100%" }}>
        {/* Left side - image background with text */}
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            position: "relative",
            backgroundImage: `url(${backgroundImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: { xs: "30vh", md: "100%" },
          }}
        >
          {/* Text over image */}
          <Box
            sx={{
              position: "absolute",
              top: { xs: "30%", md: "282px" },
              left: { xs: "20px", md: "186px" },
              width: { xs: "90%", md: "600px" },
              color: "white",
              opacity: 1,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "32px", md: "56px" },
                fontWeight: 600,
                lineHeight: 1.3,
              }}
            >
              Hey there,
              <br />
              glad you’re back!
            </Typography>
          </Box>
        </Grid>

        {/* Right side - login or children */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            backgroundColor: "#fff",
            // display: "flex",
            // alignItems: "center",
            // justifyContent: "center",
            // padding: 4,
            // height: { xs: "70vh", md: "100%" },
          }}
        >
          <Box>{children}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePageWrapper;
